import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { requestType } from "../../types/common";
import { phoneType, otpType, userType } from "../../types/login";
interface props {
  request: requestType<phoneType>;
  auth: requestType<otpType>;
  user: requestType<userType>;
  inviteUrlId?: number | string;
  userPhone: string;
  userOtp?: string | number;
}
const initialState: props = {
  request: { loading: false },
  auth: { loading: false },
  user: { loading: false },
  userPhone: "",
};
export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setRequestData(state, action: PayloadAction<phoneType>) {
      state.request.data = action.payload;
      state.request.error = null;
      state.request.loading = false;
    },
    setRequestLoading(state, action: PayloadAction<boolean>) {
      state.request.loading = action.payload;
      state.request.data = null;
      state.request.error = null;
    },
    setRequestError(state, action: PayloadAction<any>) {
      state.request.error = action.payload;
      state.request.data = null;
      state.request.loading = false;
    },
    setAuthData(state, action: PayloadAction<otpType>) {
      state.auth.data = action.payload;
      state.auth.error = null;
    },
    setAuthLoading(state, action: PayloadAction<boolean>) {
      state.auth.loading = action.payload;
      state.auth.data = null;
      state.auth.error = null;
    },
    setAuthError(state, action: PayloadAction<any>) {
      state.auth.error = action.payload;
      state.auth.data = null;
      state.auth.loading = false;
    },
    setUserData(state, action: PayloadAction<userType>) {
      state.user.data = action.payload;
      state.user.error = null;
      state.user.loading = false;
      state.auth.loading = false;
    },
    setUserLoading(state, action: PayloadAction<boolean>) {
      state.user.loading = action.payload;
      state.user.data = null;
      state.user.error = null;
    },
    setUserError(state, action: PayloadAction<any>) {
      state.user.error = action.payload;
      state.user.data = null;
      state.user.loading = false;
    },
    setInviteID(state, action: PayloadAction<number | string>) {
      state.inviteUrlId = action.payload;
    },
    setUserPhone(state, action: PayloadAction<string>) {
      state.userPhone = action.payload;
    },
    setUserOtp(state, action: PayloadAction<number | string>) {
      state.userOtp = action.payload;
    },
  },
});
export const loginAction = loginSlice.actions;
export default loginSlice.reducer;
